// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.addr-page {
  padding: 32px 48px 48px;
  max-width: 1400px;
}
@media (max-width: 991px) {
  .addr-page {
    padding: 24px 28px 36px;
  }
}
@media (max-width: 640px) {
  .addr-page {
    padding: 16px 16px 28px;
  }
}

.addr-header {
  margin-bottom: 28px;
}
.addr-header__title-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.addr-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
@media (max-width: 640px) {
  .addr-header__title {
    font-size: 22px;
  }
}
.addr-header__count {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgb(255, 121, 0), #d66600);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
}
.addr-header__count-label {
  font-size: 11px;
  font-weight: 500;
  opacity: 0.85;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.addr-breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  font-size: 12px;
}
.addr-breadcrumb li {
  display: flex;
  align-items: center;
}
.addr-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
}
.addr-breadcrumb li a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.addr-breadcrumb li a:hover {
  color: rgb(255, 121, 0);
}
.addr-breadcrumb li.addr-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.addr-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
  padding: 14px 20px;
  background: #f1f1f2;
  border-radius: 8px;
  border: 1px solid #e7eaec;
}
@media (max-width: 767px) {
  .addr-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
}
.addr-toolbar__left {
  flex: 1;
  max-width: 400px;
}
@media (max-width: 767px) {
  .addr-toolbar__left {
    max-width: none;
  }
}
.addr-toolbar__right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.addr-search {
  position: relative;
  width: 100%;
}
.addr-search__icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #ccc;
  font-size: 13px;
  pointer-events: none;
}
.addr-search__input {
  width: 100%;
  padding: 9px 36px 9px 34px;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  background: #fff;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.addr-search__input::placeholder {
  color: #ccc;
}
.addr-search__input:focus {
  border-color: rgb(255, 121, 0);
  box-shadow: 0 0 0 3px rgba(255, 121, 0, 0.1);
}
.addr-search__clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: #ccc;
  color: #fff;
  border: none;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 10px;
  padding: 0;
  transition: background 0.15s ease;
}
.addr-search__clear:hover {
  background: #676a6c;
}

.addr-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid transparent;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  text-decoration: none;
}
.addr-btn--primary {
  background: rgb(255, 121, 0);
  color: #fff;
  border-color: rgb(255, 121, 0);
}
.addr-btn--primary:hover {
  background: #d66600;
}
.addr-btn--outline {
  background: #fff;
  color: rgb(255, 121, 0);
  border-color: rgb(255, 121, 0);
}
.addr-btn--outline:hover {
  background: rgba(255, 121, 0, 0.06);
}

.addr-content {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e7eaec;
  overflow: visible;
  min-height: 200px;
}

.addr-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.addr-state > i {
  font-size: 36px;
  margin-bottom: 16px;
  color: #ccc;
}
.addr-state p {
  font-size: 15px;
  color: #676a6c;
  margin: 0 0 12px;
}

.addr-table-wrap {
  overflow-x: auto;
}

.addr-table {
  width: 100%;
  border-collapse: collapse;
}
.addr-table thead {
  background: #f1f1f2;
}
.addr-table thead th {
  padding: 12px 16px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6d6e71;
  border-bottom: 2px solid #e7eaec;
  text-align: left;
  white-space: nowrap;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.addr-table thead th i.fa {
  margin-left: 4px;
  font-size: 12px;
  color: #ccc;
}
.addr-table tbody tr {
  transition: background-color 0.12s ease;
  border-bottom: 1px solid #e7eaec;
}
.addr-table tbody tr:hover {
  background-color: rgba(255, 121, 0, 0.03);
}
.addr-table tbody tr:nth-of-type(even) {
  background-color: rgba(241, 241, 242, 0.5);
}
.addr-table tbody tr:nth-of-type(even):hover {
  background-color: rgba(255, 121, 0, 0.03);
}
.addr-table tbody tr td {
  padding: 12px 16px;
  font-size: 13px;
  color: #676a6c;
  vertical-align: middle;
}
.addr-table__sortable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: color 0.15s ease;
}
.addr-table__sortable:hover {
  color: rgb(255, 121, 0);
}
.addr-table__sortable:hover i.fa {
  color: rgb(255, 121, 0);
}
.addr-table__name {
  display: block;
  font-weight: 600;
  color: #6d6e71;
}
.addr-table__sub {
  display: block;
  font-size: 12px;
  color: #ccc;
  margin-top: 2px;
}
.addr-table__actions-col {
  width: 90px;
  text-align: left;
}
.addr-table__actions {
  white-space: nowrap;
  text-align: left;
}
.addr-table__action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0 2px;
  border-radius: 5px;
  font-size: 12px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease;
}
.addr-table__action--edit {
  background: rgba(0, 173, 208, 0.08);
  color: rgb(0, 173, 208);
  border-color: rgba(0, 173, 208, 0.15);
}
.addr-table__action--edit:hover {
  background: rgb(0, 173, 208);
  color: #fff;
}
.addr-table__action--delete {
  opacity: 0;
  pointer-events: none;
  background: rgba(245, 67, 89, 0.08);
  color: rgb(245, 67, 89);
  border-color: rgba(245, 67, 89, 0.15);
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;
}
.addr-table__action--delete:hover {
  background: rgb(245, 67, 89);
  color: #fff;
}

.addr-table tbody tr:hover .addr-table__action--delete {
  opacity: 1;
  pointer-events: auto;
}

.addr-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid #e7eaec;
}
.addr-pagination__perpage {
  display: flex;
  align-items: center;
  gap: 8px;
}
.addr-pagination__perpage label {
  font-size: 12px;
  font-weight: 600;
  color: #6d6e71;
  margin: 0;
}
.addr-pagination__perpage select {
  width: 70px;
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  color: #676a6c;
  background: #fff;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.addr-pagination__perpage select:focus {
  border-color: rgb(255, 121, 0);
  outline: none;
}
.addr-pagination__pages {
  display: flex;
  gap: 4px;
}
.addr-pagination__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  color: #676a6c;
  background: #fff;
  cursor: pointer;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  transition: all 0.15s ease;
}
.addr-pagination__btn:hover {
  background: #f1f1f2;
  border-color: #ccc;
}
.addr-pagination__btn--active {
  background: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/addresses/addresses.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA7YA;EACE,uBAAA;EACA,iBAAA;AAgZF;AA/YE;EAHF;IAG8B,uBAAA;EAmZ5B;AACF;AAnZE;EAJF;IAI8B,uBAAA;EAuZ5B;AACF;;AArZA;EACE,mBAAA;AAwZF;AAvZE;EAAe,aAAA;EAAe,mBAAA;EAAqB,SAAA;AA4ZrD;AA3ZE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cD6B3B;EC7BuD,SAAA;EAAW,uBAAA;EAAyB,wEDXnG;AC8ab;AAlaI;EADF;IAC8B,eAAA;EAsa9B;AACF;AAraE;EAAW,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,YAAA;EAAc,eAAA;EAAiB,mBAAA;EAAqB,8DAAA;EAA+E,WAAA;EAAa,eAAA;EAAiB,gBAAA;AAibnO;AAhbI;EAAU,eAAA;EAAiB,gBAAA;EAAkB,aAAA;EAAe,yBAAA;EAA2B,sBAAA;AAub3F;;AAnbA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,gBAAA;EAAkB,UAAA;EAAY,eAAA;EAAiB,eAAA;AA4btG;AA3bE;EAAK,aAAA;EAAe,mBAAA;AA+btB;AA9bI;EAA4B,YAAA;EAAc,aAAA;EAAe,WDqBzC;AC8apB;AAlcI;EAAI,cDaa;ECbe,qBAAA;EAAuB,4BAAA;AAuc3D;AAvcyF;EAAU,uBAAA;AA0cnG;AAzcI;EAA6B,cDiBZ;ECjBwC,gBAAA;AA6c7D;;AAzcA;EAAgB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,mBAAA;EAAqB,kBAAA;EAAoB,mBDgBlH;EChBoJ,kBAAA;EAAoB,yBAAA;AAqd9L;AApdE;EADF;IAC8B,sBAAA;IAAwB,oBAAA;IAAsB,SAAA;EA0d1E;AACF;AA1dE;EAAU,OAAA;EAAS,gBAAA;AA8drB;AA9duC;EAArC;IAAiE,eAAA;EAkejE;AACF;AAleE;EAAW,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAuejD;;AApeA;EAAe,kBAAA;EAAoB,WAAA;AAyenC;AAxeE;EAAU,kBAAA;EAAoB,UAAA;EAAY,QAAA;EAAU,2BAAA;EAA6B,WDQ/D;ECR0F,eAAA;EAAiB,oBAAA;AAif/H;AAhfE;EAAW,WAAA;EAAa,0BAAA;EAA4B,yBAAA;EAAiC,kBAAA;EAAoB,eAAA;EAAiB,wEDnC/G;ECmCyI,cAAA;EAA4B,gBAAA;EAAkB,aAAA;EAAe,wDAAA;AA4fnN;AA3fI;EAAiB,WDMD;ACwfpB;AA7fI;EAAU,8BDfC;ECe4B,4CAAA;AAigB3C;AA/fE;EAAW,kBAAA;EAAoB,UAAA;EAAY,QAAA;EAAU,2BAAA;EAA6B,gBDGhE;ECHgG,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,WAAA;EAAa,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,eAAA;EAAiB,UAAA;EAAY,iCAAA;AAkhBzS;AAjhBI;EAAU,mBDLO;ACyhBrB;;AAhhBA;EAAY,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAAU,iBAAA;EAAmB,6BAAA;EAA+B,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,wED5C7J;EC4CuL,eAAA;EAAiB,yBAAA;EAA2B,mBAAA;EAAqB,qBAAA;AAgiBrQ;AA/hBE;EAAa,4BDvBA;ECuB2B,WAAA;EAAa,8BDvBxC;AC2jBf;AApiBoF;EAAU,mBAAA;AAuiB9F;AAtiBE;EAAa,gBAAA;EAAkB,uBDxBlB;ECwBwC,8BDxBxC;ACmkBf;AA3iBoF;EAAU,mCAAA;AA8iB9F;;AA3iBA;EAAgB,gBAAA;EAAkB,kBAAA;EAAoB,yBAAA;EAAiC,iBAAA;EAAmB,iBAAA;AAmjB1G;;AAjjBA;EAAc,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,kBAAA;EAAoB,kBAAA;AA0jBvH;AAzjBE;EAAQ,eAAA;EAAiB,mBAAA;EAAqB,WDV5B;ACwkBpB;AA7jBE;EAAI,eAAA;EAAiB,cDlBF;ECkB8B,gBAAA;AAkkBnD;;AA/jBA;EAAmB,gBAAA;AAmkBnB;;AAjkBA;EAAc,WAAA;EAAa,yBAAA;AAskB3B;AArkBE;EAAQ,mBDhBY;ACwlBtB;AAvkBI;EAAK,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAAwB,cDpB9F;ECoB0H,gCAAA;EAAwC,gBAAA;EAAkB,mBAAA;EAAqB,wED5DjN;AC+oBb;AAllBM;EAAO,gBAAA;EAAkB,eAAA;EAAiB,WDnB5B;AC0mBpB;AAplBE;EAAW,uCAAA;EAAyC,gCAAA;AAwlBtD;AAvlBI;EAAU,yCAAA;AA0lBd;AAzlBI;EAAsB,0CAAA;AA4lB1B;AA5lB6E;EAAU,yCAAA;AA+lBvF;AA9lBI;EAAK,kBAAA;EAAoB,eAAA;EAAiB,cDhCzB;ECgCqD,sBAAA;AAomB1E;AAlmBE;EAAc,eAAA;EAAiB,yBAAA;UAAA,iBAAA;EAAmB,4BAAA;AAumBpD;AAtmBI;EAAU,uBDhDC;ACypBf;AAzmBoC;EAAO,uBDhD5B;AC4pBf;AA1mBE;EAAU,cAAA;EAAgB,gBAAA;EAAkB,cDhCzB;AC+oBrB;AA9mBE;EAAS,cAAA;EAAgB,eAAA;EAAiB,WD/BxB;EC+BmD,eAAA;AAonBvE;AAnnBE;EAAiB,WAAA;EAAa,gBAAA;AAunBhC;AAtnBE;EAAa,mBAAA;EAAqB,gBAAA;AA0nBpC;AAznBE;EAAY,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAa,YAAA;EAAc,UAAA;EAAY,aAAA;EAAe,kBAAA;EAAoB,eAAA;EAAiB,6BAAA;EAA+B,eAAA;EAAiB,0BAAA;AAuoB7N;AAtoBI;EAAU,mCAAA;EAAwC,uBDxDtC;ECwD6D,qCAAA;AA2oB7E;AA3oBuH;EAAU,4BDxDjH;ECwD6I,WAAA;AA+oB7J;AA9oBI;EAAY,UAAA;EAAY,oBAAA;EAAsB,mCAAA;EAA0C,uBDtD1E;ECsDmG,qCAAA;EAA4C,uEAAA;AAspBjK;AAtpB0O;EAAU,4BDtDlO;ECsDgQ,WAAA;AA0pBlR;;AAtpBA;EAAyD,UAAA;EAAY,oBAAA;AA2pBrE;;AAzpBA;EAAmB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,kBAAA;EAAoB,6BAAA;AAiqB3G;AAhqBE;EAAa,aAAA;EAAe,mBAAA;EAAqB,QAAA;AAqqBnD;AApqBI;EAAQ,eAAA;EAAiB,gBAAA;EAAkB,cD9C1B;EC8CsD,SAAA;AA0qB3E;AAzqBI;EAAS,WAAA;EAAa,gBAAA;EAAkB,eAAA;EAAiB,yBAAA;EAAiC,kBAAA;EAAoB,cDpD7F;ECoDyH,gBAAA;EAAkB,wEDvFnJ;AC0wBb;AAnrB0L;EAAU,8BDjErL;ECiEkN,aAAA;AAurBjO;AArrBE;EAAW,aAAA;EAAe,QAAA;AAyrB5B;AAxrBE;EAAS,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,eAAA;EAAiB,YAAA;EAAc,cAAA;EAAgB,yBAAA;EAAiC,kBAAA;EAAoB,eAAA;EAAiB,gBAAA;EAAkB,cDvDjM;ECuD6N,gBAAA;EAAkB,eAAA;EAAiB,wED1FxQ;EC0FkS,0BAAA;AAysB/S;AAxsBI;EAAU,mBDhDQ;ECgD0B,kBDjD5B;AC6vBpB;AA3sBI;EAAY,mBDpDK;ECoD4B,WAAA;EAAa,qBDpDzC;ACowBrB","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../../../assets/styles/variables';\n\n.addr-page {\n  padding: 32px 48px 48px;\n  max-width: 1400px;\n  @media (max-width: 991px) { padding: 24px 28px 36px; }\n  @media (max-width: 640px) { padding: 16px 16px 28px; }\n}\n\n.addr-header {\n  margin-bottom: 28px;\n  &__title-row { display: flex; align-items: center; gap: 12px; }\n  &__title { font-size: 28px; font-weight: 700; color: $color-neutral-dark; margin: 0; letter-spacing: -0.02em; font-family: $font-stack;\n    @media (max-width: 640px) { font-size: 22px; }\n  }\n  &__count { display: inline-flex; align-items: center; gap: 5px; height: 28px; padding: 0 12px; border-radius: 14px; background: linear-gradient(135deg, $ideate-color, darken($ideate-color, 8%)); color: #fff; font-size: 14px; font-weight: 700;\n    &-label { font-size: 11px; font-weight: 500; opacity: 0.85; text-transform: uppercase; letter-spacing: 0.04em; }\n  }\n}\n\n.addr-breadcrumb { display: flex; align-items: center; list-style: none; padding: 0; margin: 0 0 8px; font-size: 12px;\n  li { display: flex; align-items: center;\n    &:not(:last-child)::after { content: '/'; margin: 0 8px; color: $color-neutral-mid; }\n    a { color: $body-content-color; text-decoration: none; transition: color 0.15s ease; &:hover { color: $ideate-color; } }\n    &.addr-breadcrumb__current { color: $color-neutral-dark; font-weight: 600; }\n  }\n}\n\n.addr-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 24px; padding: 14px 20px; background: $color-neutral-light; border-radius: 8px; border: 1px solid $color-grey-1;\n  @media (max-width: 767px) { flex-direction: column; align-items: stretch; gap: 12px; }\n  &__left { flex: 1; max-width: 400px; @media (max-width: 767px) { max-width: none; } }\n  &__right { display: flex; align-items: center; gap: 10px; }\n}\n\n.addr-search { position: relative; width: 100%;\n  &__icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: $color-neutral-mid; font-size: 13px; pointer-events: none; }\n  &__input { width: 100%; padding: 9px 36px 9px 34px; border: 1px solid $color-grey-1; border-radius: 6px; font-size: 13px; font-family: $font-stack; color: $body-content-color; background: #fff; outline: none; transition: border-color 0.2s ease, box-shadow 0.2s ease;\n    &::placeholder { color: $color-neutral-mid; }\n    &:focus { border-color: $ideate-color; box-shadow: 0 0 0 3px rgba($ideate-color, 0.1); }\n  }\n  &__clear { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: $color-neutral-mid; color: #fff; border: none; border-radius: 50%; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 10px; padding: 0; transition: background 0.15s ease;\n    &:hover { background: $body-content-color; }\n  }\n}\n\n.addr-btn { display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; border: 1px solid transparent; border-radius: 6px; font-size: 13px; font-weight: 600; font-family: $font-stack; cursor: pointer; transition: all 0.2s ease; white-space: nowrap; text-decoration: none;\n  &--primary { background: $ideate-color; color: #fff; border-color: $ideate-color; &:hover { background: darken($ideate-color, 8%); } }\n  &--outline { background: #fff; color: $ideate-color; border-color: $ideate-color; &:hover { background: rgba($ideate-color, 0.06); } }\n}\n\n.addr-content { background: #fff; border-radius: 8px; border: 1px solid $color-grey-1; overflow: visible; min-height: 200px; }\n\n.addr-state { display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 60px 20px; text-align: center;\n  & > i { font-size: 36px; margin-bottom: 16px; color: $color-neutral-mid; }\n  p { font-size: 15px; color: $body-content-color; margin: 0 0 12px; }\n}\n\n.addr-table-wrap { overflow-x: auto; }\n\n.addr-table { width: 100%; border-collapse: collapse;\n  thead { background: $color-neutral-light;\n    th { padding: 12px 16px; font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em; color: $color-neutral-dark; border-bottom: 2px solid $color-grey-1; text-align: left; white-space: nowrap; font-family: $font-stack;\n      i.fa { margin-left: 4px; font-size: 12px; color: $color-neutral-mid; }\n    }\n  }\n  tbody tr { transition: background-color 0.12s ease; border-bottom: 1px solid $color-grey-1;\n    &:hover { background-color: rgba($ideate-color, 0.03); }\n    &:nth-of-type(even) { background-color: rgba($color-neutral-light, 0.5); &:hover { background-color: rgba($ideate-color, 0.03); } }\n    td { padding: 12px 16px; font-size: 13px; color: $body-content-color; vertical-align: middle; }\n  }\n  &__sortable { cursor: pointer; user-select: none; transition: color 0.15s ease;\n    &:hover { color: $ideate-color; i.fa { color: $ideate-color; } }\n  }\n  &__name { display: block; font-weight: 600; color: $color-neutral-dark; }\n  &__sub { display: block; font-size: 12px; color: $color-neutral-mid; margin-top: 2px; }\n  &__actions-col { width: 90px; text-align: left; }\n  &__actions { white-space: nowrap; text-align: left; }\n  &__action { display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; padding: 0; margin: 0 2px; border-radius: 5px; font-size: 12px; border: 1px solid transparent; cursor: pointer; transition: all 0.15s ease;\n    &--edit { background: rgba($clarify-color, 0.08); color: $clarify-color; border-color: rgba($clarify-color, 0.15); &:hover { background: $clarify-color; color: #fff; } }\n    &--delete { opacity: 0; pointer-events: none; background: rgba($implement-color, 0.08); color: $implement-color; border-color: rgba($implement-color, 0.15); transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease; &:hover { background: $implement-color; color: #fff; } }\n  }\n}\n\n.addr-table tbody tr:hover .addr-table__action--delete { opacity: 1; pointer-events: auto; }\n\n.addr-pagination { display: flex; align-items: center; justify-content: space-between; padding: 16px 20px; border-top: 1px solid $color-grey-1;\n  &__perpage { display: flex; align-items: center; gap: 8px;\n    label { font-size: 12px; font-weight: 600; color: $color-neutral-dark; margin: 0; }\n    select { width: 70px; padding: 4px 8px; font-size: 13px; border: 1px solid $color-grey-1; border-radius: 4px; color: $body-content-color; background: #fff; font-family: $font-stack; &:focus { border-color: $ideate-color; outline: none; } }\n  }\n  &__pages { display: flex; gap: 4px; }\n  &__btn { display: inline-flex; align-items: center; justify-content: center; min-width: 32px; height: 32px; padding: 0 8px; border: 1px solid $color-grey-1; border-radius: 4px; font-size: 13px; font-weight: 500; color: $body-content-color; background: #fff; cursor: pointer; font-family: $font-stack; transition: all 0.15s ease;\n    &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; }\n    &--active { background: $color-neutral-dark; color: #fff; border-color: $color-neutral-dark; }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
